export const painPoints: string[] = [
  'Hours spent searching for drills, progressions and class ideas',
  'Repeating the same kicking and sparring exercises because they are the easiest ones to remember',
  'Sessions that feel disconnected from one week to the next',
  'Mixed-level groups that are difficult to organize',
  'Students progressing without a clear development pathway',
  'More time planning and less time actually coaching',
  'Entering class with ideas instead of a complete structure',
]
